module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Introduction"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Introduction ")])])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Making a batch of marshmallows is so simple you’ll kick yourself for not having done it\n        sooner. It’s always been a mystery to me that people don’t make marshmallows at home. It’s\n        fast, it’s easy, and it’s fun. So why isn’t everyone making marshmallows? ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("While I was working on a marshmallow issue for my Web site, I made dozens of batches while\n        developing the recipes. Loaded up with hundreds of marshmallows from my endeavors, I\n        delivered bags of assorted flavors to my friends, and received the same reaction from every\n        one of them: “You made these at home? These are delicious! I didn’t know you could make\n        marshmallows at home!” So that was it: people don’t make marshmallows because they don’t\n        know they can. They have no idea it’s so easy. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("It’s no secret that Americans love marshmallows—we consume more than 90 million pounds a\n        year. We eat them in ice cream, cookies, fudge, candy bars, and s’mores. We add them to hot\n        chocolate. We enjoy them out of hand, roast them over campfires, and use them to decorate\n        birthday cakes. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("As adults become more interested in the nostalgic foods of our childhoods, we’re making\n        them ourselves, but with higher-quality, more wholesome, and vastly more interesting\n        ingredients than what the mass producers use. Homemade marshmallows are no different. The\n        basic recipe uses just 6 ingredients: unflavored gelatin, water, cane sugar, cane sugar\n        syrup, salt, and vanilla. Pure and simple. No additives, no chemical preservatives. And\n        marshmallows can be mixed and molded in 30 to 40 minutes. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("But the big surprise is how easy it is to make them in a myriad of flavors. If you want,\n        you can replace some or all of the water with juice, liqueur, wine, or any other liquid. You\n        can replace the sugar syrup with honey or molasses, infuse the marshmallows with spices or\n        herbs, or add freshly made or frozen fruit puree or natural flavorings. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("This book gives you all the information you need to create your own homemade marshmallows,\n        marshmallow fluff, and even cute little “peepers” in dozens of unique and delicious flavors.\n        You’ll find step-by-step instructions for making basic marshmallows and marshmallow fluff,\n        along with ideas for using them in amusing ways. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e80",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Baking has been a lifelong passion for me, including ownership of an award-winning bakery,\n        which I have since sold, and I’ve included some of the recipes my family and friends love\n        most for you to serve with your marshmallows and fluff. If you have questions, please visit\n        my Web site at ")]), _c('a', {
    staticClass: "ulink",
    attrs: {
      "href": "http://www.HomemadeGourmetMarshmallows.com",
      "target": "_blank"
    }
  }, [_vm._v("www.HomemadeGourmetMarshmallows.com")]), _vm._v(" and send me an e-mail. Have fun\n        experimenting with the simple recipes in this book, and enjoy making homemade marshmallows\n        and marshmallow fluff in a variety of versatile forms. Just remember to share!")]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of syrup."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of syrup.",
      "src": "images/070402_gormarsh_0039.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef27399","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 69
// module chunks = 0